import get from "../get";
import { GET_USER_AVATAR } from "../../userEndpoints";

export const getUserAvatar = async (userEmail, authToken) => {

    try {

        const result = await get(GET_USER_AVATAR(userEmail), authToken);
        const json = await result.json();
        return json;

    } catch (e) {
        console.log(e);
        throw e;
    }

};
